import { Clock, ShieldOff, AlertTriangle } from 'lucide-react'

interface AuthErrorScreenProps {
  type: 'session_expired' | 'account_blocked' | 'unknown_error'
  message?: string
  actionLabel?: string
  actionHref?: string
}

const config = {
  session_expired: {
    Icon: Clock,
    title: 'Session expired',
    defaultMessage: 'Your session has expired. Please sign in again to continue.',
    border: 'border-amber-200',
    iconBg: 'bg-amber-50',
    iconColor: 'text-amber-500',
  },
  account_blocked: {
    Icon: ShieldOff,
    title: 'Account unavailable',
    defaultMessage: 'Your account has been blocked. Please contact your administrator.',
    border: 'border-red-200',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-500',
  },
  unknown_error: {
    Icon: AlertTriangle,
    title: 'Something went wrong',
    defaultMessage: 'Please try again or contact support.',
    border: 'border-red-200',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-500',
  },
} as const

export function AuthErrorScreen({ type, message, actionLabel, actionHref }: AuthErrorScreenProps) {
  const { Icon, title, defaultMessage, border, iconBg, iconColor } = config[type]

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-8">
      <div className={`max-w-md w-full bg-white ${border} border rounded-xl p-8 text-center`}>
        <div className={`inline-flex items-center justify-center w-16 h-16 ${iconBg} rounded-full mb-4`}>
          <Icon className={`w-8 h-8 ${iconColor}`} />
        </div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">{title}</h2>
        <p className="text-sm text-gray-600 mb-6">
          {message || defaultMessage}
        </p>
        <a
          href={actionHref || '/auth/logout'}
          className="inline-block px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800"
        >
          {actionLabel || 'Sign out'}
        </a>
      </div>
    </div>
  )
}
